export const ADD_ZONE = "ADD_ZONE";
export const ADD_PLOT = "ADD_PLOT";
export const ADD_CROPLAND = "ADD_CROPLAND";
export const FETCH_FROM_LOCAL_STORAGE = "FETCH_FROM_LOCAL_STORAGE";
export const DELETE_ZONE = "DELETE_ZONE";
export const DELETE_PLOT = "DELETE_PLOT";
export const DELETE_CROPLAND = "DELETE_CROPLAND";
export const ADD_TASK = "ADD_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const FETCH_TASK_FROM_LOCAL_STORAGE = "FETCH_TASK_FROM_LOCAL_STORAGE";